import { createGetAllApi } from "@api/util/createGetAllApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";
import type { ISubscriptionResponse } from "@api/subscriptions/types";
import type {
  IInstallmentsGetAllParams,
  IInstallmentsResponse,
} from "src/api/installments/types";

import type { IPathBaseParam } from "./path";

const getAllApis = createGetAllApi<
  IApiResponse<
    IPagination<IInstallmentsResponse, { subscription: ISubscriptionResponse }>
  >,
  IPathBaseParam,
  IPaginationParams & IInstallmentsGetAllParams
>("subscriptions.subscriptionInstallments");

export const subscriptionInstallments = {
  ...getAllApis,
};
